<div class="container-modal">
	<div class="flex justify-center flex-col items-center" mat-dialog-content>
		<img class="w-14 h-14" [src]="this.data.badgeUrl" />
		<div class="font-semibold text-2xl mt-3 text-black">{{ this.data.name }}</div>
		<div class="text-[#7B7B7B] text-center px-10 text-sm mt-2">
			{{ this.data.description }}
		</div>
		<div class="flex justify-center mt-5">
			<button
				(click)="onClose()"
				class="text-white bg-red-600 hover:bg-red-800 focus:outline-none dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
				Tutup
			</button>
		</div>
	</div>
</div>
